/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"

import { DatePicker } from "@/atoms"
import { getDate } from "@/helpers/date.helpers"
import { RANGE_DATE_PICKER_FILTER } from "@/helpers/filters.helper"
import { useFilters } from "@/hooks/useFilters"
import { useLogger } from "@/hooks/useLogger"

import type { Dayjs } from "@/helpers/date.helpers.types"
import type { RangePickerFilterProps } from "."

export const RangePickerFilter = (props: RangePickerFilterProps) => {
  const { placement, isLoading, format = "ll" } = props
  const { from: fromFieldName, to: toFieldName } = RANGE_DATE_PICKER_FILTER

  const { searchParamsProps } = useFilters()
  const { original: searchParams, updateSearchParams: setSearchParams } =
    searchParamsProps
  const { logger, EVENTS } = useLogger()
  const [defaultValue, setDefaultValue] = useState<[Dayjs, Dayjs] | undefined>()
  const fromDateParam = searchParams.get(fromFieldName)
  const toDateParam = searchParams.get(toFieldName)

  useEffect(() => {
    const fromDate = getDate(`${fromDateParam}T12:00:00Z`)
    const toDate = getDate(`${toDateParam}T12:00:00Z`)

    if (fromDate.isValid() && toDate.isValid())
      return setDefaultValue([fromDate, toDate] as [Dayjs, Dayjs])

    searchParams.delete(fromFieldName)
    searchParams.delete(toFieldName)
    setSearchParams(searchParams)
    setDefaultValue(undefined)
  }, [fromDateParam, toDateParam])

  return (
    <DatePicker.RangePicker
      key={defaultValue?.length}
      disabled={isLoading}
      format={format}
      defaultValue={defaultValue}
      onChange={(values) => {
        if (!values) {
          const fromDateParam = searchParams.get(fromFieldName)
          const toDateParam = searchParams.get(toFieldName)

          if (fromDateParam || toDateParam) {
            searchParams.delete(fromFieldName)
            searchParams.delete(toFieldName)
            setSearchParams(searchParams)
          }

          return
        }

        const [from, to] = values

        if (!from || !to) return

        const getDate = (date: typeof from) =>
          `${date.year()}-${String(date.month() + 1).padStart(2, "0")}-${String(date.date()).padStart(2, "0")}`

        const fromDate = getDate(from)
        const toDate = getDate(to)

        if (fromDate && toDate) {
          searchParams.set(fromFieldName, `${fromDate}`)
          searchParams.set(toFieldName, `${toDate}`)
          searchParams.set("pageNumber", "0")
          setSearchParams(searchParams)

          logger.info(EVENTS.ANALYTIC_EVENTS.TAB.FILTER.QUICK_FILTERS, {
            placement,
            name: "RangePicker",
            from: fromDate,
            to: toDate
          })
        }
      }}
    />
  )
}
